/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as JsStore from "jsstore";
import { DATA_TYPE } from "jsstore";
import { DICOM_DICT_VERSION } from "../../constant";
import JSStoreWorkerUrl from "jsstore/dist/jsstore.worker.min.js?url";
import { getSubDomain, jsStoreReplaceFunction } from "../../helpers";

// This will ensure that we are using only one instance.
// Otherwise due to multiple instance multiple worker will be created.

const urlDecode = new URL(JSStoreWorkerUrl, window.location.origin).toString();
const path = jsStoreReplaceFunction(urlDecode, getSubDomain());
export const idbCon = new JsStore.Connection(
  new Worker(path, { name: "JSStoreWorker", type: "module" })
);
export const dbName = "Dicom";

const getDatabase = () => {
  const tblDictionaryVersion = {
    name: "Version",
    columns: {
      id: {
        primaryKey: true,
        autoIncrement: true,
      },
      version: {
        notNull: true,
        dataType: DATA_TYPE.Number,
      },
    },
  };
  const tblDictionary = {
    name: "Dictionary",
    columns: {
      id: {
        primaryKey: true,
        autoIncrement: true,
      },
      tag: {
        notNull: true,
        dataType: DATA_TYPE.String,
      },
      name: {
        notNull: true,
        dataType: DATA_TYPE.String,
      },
      vr: {
        notNull: true,
        dataType: DATA_TYPE.String,
      },
    },
  };
  const dataBase = {
    name: dbName,
    tables: [tblDictionaryVersion, tblDictionary],
  };
  return dataBase;
};

const checkData = async () => {
  try {
    const version: any[] = await idbCon.select({
      from: "Version",
      order: {
        by: "version",
        type: "desc",
      },
      limit: 1,
    });

    if (
      version.length === 0 ||
      (version.length === 1 && version[0].version < DICOM_DICT_VERSION)
    ) {
      const dictionary = await import(
        "@advapacs/common/src/assets/dicom/dictionary.json"
      );
      await idbCon.clear("Version");
      // Insert new version
      await idbCon.insert({
        into: "Version",
        values: [{ version: DICOM_DICT_VERSION }],
      });

      await idbCon.clear("Dictionary");
      await idbCon.insert({
        into: "Dictionary",
        values: dictionary.data,
      });
    }
  } catch (e) {
    console.log(e);
  }
};

export const initJsStore = () => {
  try {
    const dataBase = getDatabase();
    idbCon
      .initDb(dataBase)
      .then(() => checkData())
      .finally();
  } catch (err) {
    console.error(err);
  }
};
